import React from 'react'

import NavBarItem from './NavBarItem'
import { StyledBar } from './styled'

const Bar = ({ label, labelInfo, navContent, getLink, className, height, withoutTopMenu, subNav }) => {
	return(
		<>
			{!withoutTopMenu &&
				<StyledBar height={height} subNav={subNav} className='NavBar-bar'>
					{navContent.map((props, i) => <NavBarItem key={i} getLink={getLink} {...props}/>)}
				</StyledBar>
			}
		</>
	)
}

export default Bar
